export const mapProductsLite = (body, tags = []) => {
    const liteAddons = body.addons?.map((addon) => {
        const newChannels = addon.channels?.map((channel) => channel.stationId);
        const liteAddon = {
            ...addon,
            channels: newChannels ? [...new Set(newChannels)] : undefined,
        };
        return liteAddon;
    });
    const liteProducts = body.products.map((product) => {
        const newChannels = product.channels?.map((channel) => channel.stationId);
        const liteProduct = {
            ...product,
            channels: newChannels ? [...new Set(newChannels)] : undefined,
        };
        return liteProduct;
    });
    const extraQuery = {
        count: body.extra_query?.count ?? 0,
    };
    const result = {
        addons: liteAddons,
        products: liteProducts,
        extraQuery,
        tags,
    };
    return result;
};
